import { IJsonQuery } from '../../../../packages/api-models/common/json_query';
import { FILTERS_SET_DATES } from '../../../actions/filters/dates';
import { TReduxActions } from '../../../types/redux';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function setDatesReducer(state: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_DATES:
      return new JsonQuery(state).setDates(action.payload.gte, action.payload.lt).getSerializable();

    default:
      return state;
  }
}
